var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('EventSlideshow',{attrs:{"noPastEvents":"","title":"MY EVENTS","noSelectBox":""}})],1),_c('div',{staticClass:"EventList"},[_c('MyEventList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }